export const DETAILED_ALTERATION_IMAGE_ADDED = "detailed_alteration_image_added"